<template>
    <div class="card">
        <div class="card-header">Payment and Contact Information</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <h2>Application Fee Schedule</h2>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    To pay your application fee, as displayed below, the next screen will take you to the US Bank e-payment portal. There you can
                    pay using a credit/debit card or by check (ACH). There is no fee to pay by check online, however a convenience fee will be
                    added to credit/debit card payments.
                    <p class="font-weight-bold mt-2">Please note an NSF fee may be applied on all returned e-check payments.</p>
                    
                    <p style="font-size:2em;" class="mt-3 mb-3">{{licenseFee | currency}}</p>

                    <b-row>
                        <b-col>
                            <BaseCheckboxInput v-model="isCheck"
                                               :v="$v.isCheck"
                                               :label="checkLabel"
                                               slug="isCheck"
                            />
                        </b-col>
                    </b-row>

                    <p>Clicking Finish will save your application and redirect you to the USBank for payment if the above checkbox is not checked or
                        instructions to submit your payment by check if it is.</p>
                </b-col>
            </b-row>
        </div>
    </div>

</template>
<script>
import axios from "axios"
var jp = require('jsonpath');

    export default {
        data: () => {
            return {
                fees: {},
                loaded: false,
                licenseFee: 0,
                isCheck: false,
                checkLabel: "Check here if you intend to pay by money order, cashier's check or moneygram. The next screen will give instructions " +
                    "on how to do this. Please note there will be a longer processing time for these payment types which may delay the approval of " +
                    "your application."
            }
        },
        
        props: {
            application: [Object]
        },

        validations() {
            return {
                isCheck: { required: false }
            }
        },

        watch: {
            application() {
                if (!this.loaded && this.application && this.application.subCategory) {
                    this.loadFees()
                }
            }
        },
        
        methods: {
            async loadFees() {
                await axios.get(`${process.env.VUE_APP_API_BASE_URL}/fees/${this.application.subCategory}`)
                    .then(response => { 
                        this.fees = response.data
                        var fee = jp.query(this.fees, '$..licenseFee', 1);
                        this.licenseFee = fee[0]
                        this.loaded = true
                    })
            },

            validate() {
                this.$emit('on-validate', this.$data, true)
                return true
            }
        }
    }
</script>